import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const ExerciseCard = ({ 
  exercise, 
  isActive = false,
  isCompleted = false,
  onClick 
}) => {
  return (
    <button
      onClick={onClick}
      className={`
        w-full text-left rounded-lg border transition-smooth hover-lift press-scale
        ${isActive 
          ? 'border-accent bg-accent/10 shadow-md' 
          : isCompleted 
            ? 'border-success bg-success/5' :'border-border bg-card hover:border-primary/30'
        }
      `}
      aria-label={`${exercise?.name} - ${isCompleted ? 'Completed' : isActive ? 'Current' : 'Upcoming'}`}
    >
      <div className="flex items-center gap-3 p-3 md:p-4">
        <div className="relative flex-shrink-0">
          <div className="w-16 h-16 md:w-20 md:h-20 rounded-lg overflow-hidden bg-muted">
            <Image
              src={exercise?.image}
              alt={exercise?.imageAlt}
              className="w-full h-full object-cover"
            />
          </div>
          {isCompleted && (
            <div className="absolute -top-1 -right-1 w-6 h-6 rounded-full bg-success flex items-center justify-center">
              <Icon name="Check" size={14} color="var(--color-success-foreground)" strokeWidth={3} />
            </div>
          )}
        </div>

        <div className="flex-1 min-w-0">
          <h4 className="font-heading font-semibold text-sm md:text-base text-foreground truncate">
            {exercise?.name}
          </h4>
          <p className="text-xs md:text-sm text-muted-foreground mt-1">
            {exercise?.sets} sets × {exercise?.reps} reps
          </p>
          {exercise?.weight && (
            <p className="text-xs caption text-muted-foreground mt-0.5">
              {exercise?.weight} lbs
            </p>
          )}
        </div>

        <div className="flex-shrink-0">
          {isActive ? (
            <div className="w-8 h-8 rounded-full bg-accent flex items-center justify-center">
              <Icon name="Play" size={16} color="var(--color-accent-foreground)" strokeWidth={2.5} />
            </div>
          ) : isCompleted ? (
            <Icon name="CheckCircle2" size={24} color="var(--color-success)" strokeWidth={2} />
          ) : (
            <Icon name="Circle" size={24} color="var(--color-muted-foreground)" strokeWidth={2} />
          )}
        </div>
      </div>
    </button>
  );
};

export default ExerciseCard;